// extracted by mini-css-extract-plugin
module.exports = {"container":"Cart_container__oCv__","promoInput":"Cart_promoInput__OLrgN","section":"Cart_section__DKf8M","sectionSmallGap":"Cart_sectionSmallGap__YUVLz"};